// extracted by mini-css-extract-plugin
module.exports = {"logoTitle":"header_logo_title-module--logoTitle--33u6r"};